import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const InputsBox = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    color: ${theme.colors.secondary};
  `}
`

export const Separator = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    height: 1px;
    margin-top: 40px;
    background: ${theme.colors.gray.light};
  `}
`

export const BottomBox = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;

    font-size: 18px;
    line-height: 18px;
    font-weight: 600;
    color: ${theme.colors.error.color};

    @media (max-width: ${theme.screenSizes.laptop}) {
      margin-top: 16px;
      font-size: 16px;
      line-height: 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }
  `}
`

export const Buttons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    margin-top: 32px;
    justify-content: flex-end;

    @media (max-width: ${theme.screenSizes.laptop}) {
      width: 100%;
      align-items: center;
      justify-content: flex-end;
      gap: 16px;
      margin-top: 0px;
    }
  `}
`
